module.exports = __webpack_public_path__ + "assets/SAMSUNG_25_5_ikony_sft_KR_ready-04.e42af230.svg";